import React from "react";
import { Container } from "react-bootstrap";
import InvitationsCards from "../components/InvitationsCards";

const PendingInvitationsPage: React.FC = () => {
  return (
    <Container fluid className="py-4" data-testid="pending-invitations-container">
      <div className="ntcog-page-title-block mb-4">
        <h1 className="ntcog-page-heading mb-1" data-testid="pending-invitations-title">
          Pending Invitations
        </h1>
        <p className="text-muted mb-0" data-testid="pending-invitations-description">
          Review and respond to your pending invitations.
        </p>
      </div>

      <InvitationsCards showPagination={true} />
    </Container>
  );
};

export default PendingInvitationsPage;
